(() => {
	const fileInputs = document.querySelectorAll('.fileinput');
	const passwordInputs = document.querySelectorAll('.form__item--password');
	
	fileInputs.forEach(input => {
		input.addEventListener('change', e => {
			const filePath = e.target.value;
			const fileName = filePath ?filePath.split('\\').pop() : '';
			const fileWrapper = input.closest('.fileinput__group');
			const resultDiv = fileWrapper.querySelector('.fileinput__result');
			resultDiv.innerHTML = `${fileName}`;
		});
	});

	passwordInputs.forEach(field => {
		const input = field.querySelector('input');
		const toggle = field.querySelector('.form__input-icon');
		const icon = field.querySelector('.fa-eye');
		
		toggle.addEventListener('click', function() {
			if(input.type === 'password') {
				input.type = 'text';
				icon.classList.add('fa-eye-slash');
			} else {
				input.type = 'password';
				icon.classList.remove('fa-eye-slash');
			}
		});
		
	});

	const submitBtn = document.querySelector('button.final-submit-btn');
	if (submitBtn) {
		submitBtn.addEventListener('click', () => {

			submitBtn.style.pointerEvents = 'none';
			const btnIcon = submitBtn.querySelector('.btn__icon');
			submitBtn.classList.add('btn--disabled');
			btnIcon.classList.add('fa-spinner-third', 'fa-spin');

			if (btnIcon.classList.contains('fa-chevron-right')) {
				btnIcon.classList.remove('fa-chevron-right');
				setTimeout(() => {
					btnIcon.classList.add('fa-chevron-right');
				}, 6000);
			}

			setTimeout(() => {
				submitBtn.style.pointerEvents = 'auto';
				submitBtn.classList.remove('btn--disabled');
				btnIcon.classList.remove('fa-spinner-third', 'fa-spin');
			}, 6000);

		});	
	}
})();
